<template>
    <div :class="{ 'is-loading': loading }">
        <Loader :class="{ show: loading }" />
        <RequestStatusForm
            :key="formUpdateKey"
            ref="form"
            :show-validation="showValidation"
            :results-view="resultsView"
            @user-data-updated="updateUserData" />
        <RequestStatusResults
            v-if="resultsView"
            :status-results="statusResults"
            :error-messages="errorMessages"
            :has-error="hasError" />
        <RequestStatusControls :results-view="resultsView" @submit-clicked="submitForm" @reset-clicked="resetForm" />
    </div>
</template>

<script>
import ajaxMixins from 'Root/vue/mixins/ajaxMixins'
import Loader from 'Root/vue/components/Loader.vue'
import RequestStatusForm from 'Root/vue/components/RequestStatus/RequestStatusForm.vue'
import RequestStatusControls from 'Root/vue/components/RequestStatus/RequestStatusControls.vue'
import RequestStatusResults from 'Root/vue/components/RequestStatus/RequestStatusResults.vue'

export default {
    components: {
        Loader,
        RequestStatusForm,
        RequestStatusControls,
        RequestStatusResults,
    },

    mixins: [ajaxMixins],

    data() {
        return {
            loading: false,
            hasError: false,
            errorMessages: '',
            showValidation: false,

            results: null,
            resultsView: false,

            userData: {
                fileNumber: '',
                year: '',
                requestType: '',
            },

            statusResults: {
                lastUpdatedText: '',
                statusText: '',
            },

            formUpdateKey: 0,
        }
    },

    methods: {
        submitForm() {
            if (!this.$refs.form.isValid()) {
                this.showValidation = true
                return
            }

            const payload = {
                fileNumber: this.userData.fileNumber,
                year: this.userData.year,
                requestType: this.userData.requestType,
            }

            this.ajax(this.appData.configuration.submitEndpoint, payload, this.storeResults, this.setErrorResponse)
        },

        resetForm() {
            this.resultsView = false
            this.statusResults.lastUpdatedText = ''
            this.statusResults.statusText = ''

            this.formUpdateKey++
        },

        updateUserData(data) {
            this.userData.fileNumber = data.fileNumber
            this.userData.year = data.year
            this.userData.requestType = data.requestType
        },

        storeResults(data) {
            this.statusResults.lastUpdatedText = data.lastUpdatedText
            this.statusResults.statusText = data.statusText

            this.resultsView = true
        },

        setErrorResponse() {
            this.resultsView = true
        },
    },
}
</script>
